/* PAC — theme behaviour. Small on purpose. */
(function () {
  'use strict';

  /* Mobile drawer */
  var drawer = document.querySelector('[data-drawer]');
  document.querySelectorAll('[data-drawer-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!drawer) return;
      var open = drawer.classList.toggle('is-open');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      b.setAttribute('aria-expanded', String(open));
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
  });

  /* Reveal on scroll */
  var rv = document.querySelectorAll('.rv');
  if (rv.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------------------------------------------------------------------
     Tree counter.
     Exact when Shopify Flow is updating shop.metafields.pac.trees_planted;
     otherwise the Theme-settings baseline plus a live estimate at your
     typical order rate, so the number keeps moving between updates.
     --------------------------------------------------------------------- */
  (function () {
    var el = document.getElementById('pac-trees');
    if (!el) return;
    var cfg; try { cfg = JSON.parse(el.textContent); } catch (e) { return; }

    var WEEK = 7 * 24 * 60 * 60 * 1000;
    var isExact = !!(cfg.exact && cfg.exact > 0);

    function value() {
      if (isExact) return cfg.exact;
      var n = cfg.baseline || 0;
      if (cfg.live && cfg.baselineAt && cfg.perWeek > 0) {
        var t0 = Date.parse(cfg.baselineAt);
        if (!isNaN(t0)) {
          var weeks = (Date.now() - t0) / WEEK;
          if (weeks > 0) n += Math.floor(weeks * cfg.perWeek);
        }
      }
      return n;
    }

    var nodes = document.querySelectorAll('[data-tree-count]');
    if (!nodes.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shown = 0;

    function paint(n) {
      shown = n;
      var s = n.toLocaleString();
      for (var i = 0; i < nodes.length; i++) nodes[i].textContent = s;
    }

    function animate(from, to, dur) {
      if (reduce || from === to) { paint(to); return; }
      var t0 = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        paint(Math.round(from + (to - from) * e));
        if (p < 1) requestAnimationFrame(step);
      })(performance.now());
    }

    /* the goal bar */
    var goal = document.querySelector('[data-tree-goal]');
    function paintGoal(n) {
      if (!goal || !cfg.goal || cfg.goal <= 0) return;
      goal.hidden = false;
      var pct = Math.max(0, Math.min(100, (n / cfg.goal) * 100));
      var fill = goal.querySelector('[data-goal-fill]');
      var now = goal.querySelector('[data-goal-now]');
      var left = goal.querySelector('[data-goal-left]');
      if (fill) fill.style.width = pct.toFixed(1) + '%';
      if (now) now.textContent = n.toLocaleString();
      if (left) {
        var remaining = Math.max(0, cfg.goal - n);
        left.textContent = remaining > 0
          ? remaining.toLocaleString() + ' to go — that is ' +
            Math.ceil(remaining / (cfg.perOrder || 1)).toLocaleString() + ' more orders'
          : 'Goal reached. Time for a bigger one.';
      }
    }

    /* where the number came from, said plainly */
    var src = document.querySelector('[data-tree-source]');
    if (src) {
      src.hidden = false;
      src.textContent = isExact
        ? 'Updated automatically from Shopify orders.'
        : (cfg.live && cfg.perWeek > 0
            ? 'Live estimate, updated from our order rate. Exact figures come from our planting partner each quarter.'
            : '');
      if (!src.textContent) src.hidden = true;
    }

    var started = false;
    function start() {
      if (started) return;
      started = true;
      var v = value();
      animate(0, v, 1700);
      paintGoal(v);
    }

    var big = document.querySelector('.counter__n [data-tree-count]');
    if (big && 'IntersectionObserver' in window) {
      /* small instances (header, hero, footer) get the number straight away */
      paint(value());
      var o = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { animate(0, value(), 1700); paintGoal(value()); started = true; o.disconnect(); }
      }, { threshold: 0.3 });
      o.observe(big);
      paintGoal(value());
    } else {
      start();
    }

    /* keep ticking while the tab is open */
    setInterval(function () {
      var v = value();
      if (v > shown) { animate(shown, v, 700); paintGoal(v); }
    }, 30000);
  })();

  /* Product variants */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var holder = root.querySelector('[data-variant-json]');
    if (!holder) return;
    var data; try { data = JSON.parse(holder.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var cmpEl   = root.querySelector('[data-compare]');
    var btn     = root.querySelector('[data-add]');
    var money   = root.getAttribute('data-money') || '${{amount}}';

    var fmt = function (cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
    };
    var selected = function () {
      return Array.prototype.map.call(root.querySelectorAll('[data-opt]:checked'), function (i) { return i.value; });
    };

    var update = function () {
      var sel = selected();
      var match = data.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];

      root.querySelectorAll('[data-opt]').forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-opt-index'), 10);
        input.disabled = !data.some(function (v) {
          return v.available && v.options.every(function (o, i) {
            return i === idx ? o === input.value : o === sel[i];
          });
        });
      });
      root.querySelectorAll('[data-opt-current]').forEach(function (s) {
        var idx = parseInt(s.getAttribute('data-opt-current'), 10);
        if (sel[idx]) s.textContent = sel[idx];
      });

      if (!match) { if (btn) { btn.disabled = true; } return; }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = fmt(match.price);
      if (cmpEl) {
        var show = match.compare_at_price && match.compare_at_price > match.price;
        cmpEl.hidden = !show;
        if (show) cmpEl.textContent = fmt(match.compare_at_price);
      }
      if (btn) {
        btn.disabled = !match.available;
        var label = btn.querySelector('[data-add-label]');
        if (label) label.textContent = match.available ? btn.getAttribute('data-label') : 'Sold out';
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u.toString());
      }
    };

    root.querySelectorAll('[data-opt]').forEach(function (i) { i.addEventListener('change', update); });
    update();
  });
})();
